import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import { FullWidthTextField } from '../../../shared/Forms/FullWidthForm/fullWidthFormComponents';
import { required } from '../../../shared/Forms/validations';
import { connect } from 'react-redux';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import agreementStyles from '../ClientAgreement.module.css';
import styles from './AgreementPage7.module.css';
import { Grid } from '@material-ui/core';
import { formatDollar } from '../../../shared/Forms/formats';
import { AscendState } from '../../../../ducks';
import {
  getEstimatedProgramFee,
  getEstimatedSettlementAmount,
  getEstimatedProgramSavings,
  getAscendFeeFromForm,
  getTotalDebt,
} from '../../../../ducks/onboard/onboardSelectors';

const AgreementPage7 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="none" currentPage={7} noScroll>
    <div className={agreementStyles.contentHeader}>
      Exhibit 4<br />
      Program Analysis:
      <br />
      <br />
      Program Details
      <br />
      <br />
    </div>
    <Field
      name="firstName"
      type="text"
      component={FullWidthTextField}
      label="Applicant First Name"
      validate={required}
    />
    <Field
      name="middleName"
      type="text"
      component={FullWidthTextField}
      label="Applicant Middle Name"
    />
    <Field
      name="lastName"
      type="text"
      component={FullWidthTextField}
      label="Applicant Last Name"
      validate={required}
    />
    <Field
      name="email"
      type="email"
      component={FullWidthTextField}
      label="Applicant Email"
      validate={required}
    />
    <Field
      name="phone"
      type="tel"
      component={FullWidthTextField}
      label="Applicant Phone"
      validate={required}
    />
    <FullWidthTextField
      type="text"
      fieldFormat="dollar"
      input={{
        value: formatDollar(props.totalDebt).toString(),
        name: 'totalDebt',
      }}
      label="Total Estimated Enrolled Debt*"
      disabled
    />
    <Field
      disabled
      name="draftAmount"
      type="text"
      fieldFormat="dollar"
      format={formatDollar}
      component={FullWidthTextField}
      label="Monthly Draft Amount"
      validate={required}
    />
    <FullWidthTextField
      type="text"
      fieldFormat="dollar"
      input={{
        value: formatDollar(props.totalDebt).toString(),
        name: 'totalDebt',
      }}
      label="Total Estimated Enrolled Debt*"
      disabled
    />
    <FullWidthTextField
      type="text"
      input={{
        value: 'Percentage of enrolled debt',
        name: 'feeMethod',
      }}
      label="Fee Method"
      disabled
    />
    <FullWidthTextField
      type="text"
      fieldFormat="dollar"
      input={{
        value: formatDollar(props.estimatedSettlementAmount).toString(),
        name: 'estimatedSettlementAmount',
      }}
      label="Estimated Settlement Amount"
      disabled
    />
    <FullWidthTextField
      type="text"
      fieldFormat="dollar"
      input={{
        value: formatDollar(props.estimatedProgramFee).toString(),
        name: 'estimatedProgramFee',
      }}
      label="Estimated Program Fee"
      disabled
    />
    <FullWidthTextField
      type="text"
      fieldFormat="percentage"
      input={{
        value: props.estimatedProgramFeePercent,
        name: 'estimatedProgramFeePercent',
      }}
      label="Estimated Program Fee %**"
      disabled
    />
    <FullWidthTextField
      type="text"
      input={{
        value: `${props.programLengthPayments} Payments`,
        name: 'programLengthPayments',
      }}
      label="Estimated Program Length"
      disabled
    />
    <FullWidthTextField
      type="text"
      fieldFormat="dollar"
      input={{
        value: formatDollar(props.estimatedProgramSavings).toString(),
        name: 'estimatedProgramSavings',
      }}
      label="Estimated Program Savings"
      disabled
    />
    <Grid container justify="center">
      <Grid item xs={11} className={styles.disclaimer}>
        * The Enrolled Debt shown is provided by you, as of the date of enrollment. The Estimated
        Fee, Estimated Program Length, and Estimated Program Savings are all dependent upon the
        accuracy of the provided Enrolled Debt. You authorize Ascend to validate the Enrolled Debt,
        and adjust as needed. Any change to the Enrolled Debt may impact the Estimated Fee and
        Estimated Program Length
      </Grid>
    </Grid>
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AgreementPage7 as any);

const mapStateToProps = (state: AscendState) => ({
  name: formSelector(state, 'name'),
  totalDebt: getTotalDebt(state),
  estimatedSettlementAmount: getEstimatedSettlementAmount(state),
  estimatedProgramFee: getEstimatedProgramFee(state),
  programLengthPayments: state.user.data.programLengthPayments,
  estimatedProgramSavings: getEstimatedProgramSavings(state),
  estimatedProgramFeePercent: getAscendFeeFromForm(state),
  advisorName: formSelector(state, 'advisorName'),
});

export default connect(mapStateToProps)(form) as any;
